import { render, staticRenderFns } from "./JoinCommunity.vue?vue&type=template&id=2d9a15d2&scoped=true"
import script from "./JoinCommunity.vue?vue&type=script&lang=js"
export * from "./JoinCommunity.vue?vue&type=script&lang=js"
import style0 from "./JoinCommunity.vue?vue&type=style&index=0&id=2d9a15d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9a15d2",
  null
  
)

export default component.exports